var map = {
	"./icon-level-1.png": "c64a",
	"./icon-level-2.png": "c80e",
	"./icon-level-3.png": "aa8e",
	"./icon-level-4.png": "d4b7",
	"./icon-level-5.png": "ad59"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f611";